import PropTypes from "prop-types";
import * as React from "react";
import classNames from "classnames";
import Portal from "react-portal-minimal";

import styles from "./Layout.scss";
import { HelperIcon } from "@wg/wows-react-uikit";
import { Back } from "UIKit";
import { Nav, NavClanProfile } from "UIKit";
import { roleNames } from "roles";
import { IsFromSearchContextProvider } from '../../../Providers/IsFromSearch'
import { isIngame } from '~/commonmenu'

import { t } from "helpers/localization";

const propTypes = {
  children: PropTypes.node.isRequired,
  root: PropTypes.string.isRequired,
  needShowOverlay: PropTypes.bool,
  isDialogOverlay: PropTypes.bool,
  currentAccount: PropTypes.shape({
    clanId: PropTypes.number,
    roleName: PropTypes.oneOf(roleNames),
    activeInvitesCount: PropTypes.number.isRequired,
    activeApplicationsCount: PropTypes.number.isRequired
  }).isRequired,
  routePath: PropTypes.string,
  params: PropTypes.object,

  onRouteClick: PropTypes.func.isRequired
};

const HEADER_HEIGHT = 87;
const headerWithTabsUrls = ['/clan-wars', '/clan-battles'];

class Layout extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showShadowTop: false,
      showShadowBottom: false,
      shadowPositionLeft: 0,
      shadowWidth: 0,
      prevScrollPosition: 0
    };

    this.updateShadows = this.updateShadows.bind(this);
  }

  componentDidMount() {
    this.appContainer = document.getElementById('app');
    this.appContainer.addEventListener('scroll', this.updateShadows);
    window.addEventListener('resize', this.updateShadows);
    this.updateShadows();
  }

  componentDidUpdate() {
    this.updateShadows();
  }

  componentWillUnmount() {
    this.appContainer.removeEventListener('scroll', this.updateShadows);
    window.removeEventListener('resize', this.updateShadows);
  }

  updateShadows() {
    const scrollPosition = this.appContainer.scrollTop;
    const scrollHeight = this.appContainer.scrollHeight - this.appContainer.clientHeight;

    let state = {
      showShadowTop: scrollPosition > 0,
      showShadowBottom: scrollPosition < scrollHeight,
      shadowPositionLeft: this._section.getBoundingClientRect().left,
      shadowWidth: this._section.getBoundingClientRect().width
    };

    if (scrollPosition > 0) {
      state.prevScrollPosition = scrollPosition;
    }

    this.setState(state);
  }


  renderBack() {
    return <div className={styles.back}>
                <Back />
            </div>;
  }

  renderSideBar() {
    return this.props.routePath.includes('clan-profile') ? <NavClanProfile root={this.props.root} clanId={this.props.params.clanId} onRouteClick={this.props.onRouteClick} /> : <Nav root={this.props.root} currentAccount={this.props.currentAccount} routePath={this.props.routePath} onRouteClick={this.props.onRouteClick} />;
  }

  renderStatisticHelper() {
    const inGame = isIngame()
    return (this.props.routePath.includes('profile') || this.props.routePath.includes('members')) ? <div className={inGame?styles.helperIconInGame:styles.helperIcon}>
                    <HelperIcon header={t('Статистика клана')}>
                        <div>
                            <p>{t('Статистические показатели клана расcчитываются как среднее арифметическое показателей игроков клана.:текст тултипа статистика клана строка 1')}</p>
                            <p>{t('Когда статистика игрока скрыта, количество добытых им баррелей нефти остаётся доступным для просмотра командующему и заместителям командующего.:текст тултипа статистика клана строка 2')}</p>
                            <p>{t('В статистике клана не учитывается скрытая статистика игрока, если только он один скрыл свою статистику в этом клане.:текст тултипа статистика клана строка 3')}</p>
                            <p>{t('Если в клане только один игрок, и он скрыл свою статистику, то статистика этого клана тоже будет скрыта.:текст тултипа статистика клана строка 4')}</p>
                        </div>
                    </HelperIcon>
                </div> : null;
  }

  render() {
    const classNameMain = classNames({
      overlay: this.props.needShowOverlay
    });

    const classNameShadowTop = classNames(styles.shadowTop, {
      [styles.isVisible]: this.state.showShadowTop
    });

    const classNameShadowBottom = classNames(styles.shadowBottom, {
      [styles.isVisible]: this.state.showShadowBottom
    });

    let bottomStyle = {
      left: this.state.shadowPositionLeft,
      width: this.state.shadowWidth
    };

    let topStyle = {
      left: this.state.shadowPositionLeft,
      width: this.state.shadowWidth
    };

    let needUpdateHeader = false;

    headerWithTabsUrls.forEach(url => {
      if (!needUpdateHeader && this.props.routePath.indexOf(url) !== -1) {
        needUpdateHeader = true;
      }
    });

    if (needUpdateHeader) {//topStyle.top = HEADER_HEIGHT
    }

    const isDialogOverlay = this.props.needShowOverlay && !this.props.isDialogOverlay;
    const classNameAside = classNames(styles.aside, {
      [styles.isDialogOverlay]: isDialogOverlay
    });
    const classNameSideBarWrapper = classNames({
      overlayable: true,
      overlay: isDialogOverlay
    });


    if (this.appContainer && this.state.prevScrollPosition > 0 && this.appContainer.scrollTop === 0 && window.holdScrollPosition) {
      this.appContainer.scrollTop = this.state.prevScrollPosition;
    }

    const isOpenedFromSearch = this.props.routePath.includes('clan-profile')

    return (
      <IsFromSearchContextProvider
          isFromSearch={isOpenedFromSearch}
      >
          <main className={classNameMain}>
              {this.props.routePath.includes('clan-profile') && this.renderBack()}
              {this.renderStatisticHelper()}
              <Portal>
                  <aside className={classNameAside}>
                      <div className={classNameSideBarWrapper}>
                          {this.renderSideBar()}
                      </div>
                  </aside>
              </Portal>
              <section
                  className={styles.section}
                  ref={(c) => this._section = c}
              >
                  <div className={classNameShadowTop} style={topStyle} />
                  {this.props.children}
                  <div className={classNameShadowBottom} style={bottomStyle} />
              </section>
          </main>
      </IsFromSearchContextProvider>
    )
  }
}

Layout.propTypes = propTypes;

export default Layout;